class Menu {
  constructor() {
    this.init = this.init.bind(this);
    this.toggle = this.toggle.bind(this);
    document.addEventListener("DOMContentLoaded", this.init);
  }
  init() {
    this.menu = document.querySelector('.m-menu');
    if ( this.menu === null) {
      console.warn("Mobile menu base node is null");
      return;
    }
    this.burger = document.querySelector(".burger");
    if ( this.burger === null ) {
      console.warn("Burger button has not found");
      return;
    }
    this.visible = false;
    this.burger.addEventListener('click', this.toggle);
  }
  toggle() {
    if (this.visible) {
      this.hide();
    } else {
      this.show();
    }
  }
  show() {
    this.menu.scrollTop = 0;
    this.menu.classList.add("m-menu--active");
    this.burger.classList.add("burger--close");
    this.visible = true;
    document.documentElement.style.overflow = "hidden";
  }
  hide() {
    this.menu.classList.remove("m-menu--active");
    this.burger.classList.remove("burger--close");
    this.visible = false;
    document.documentElement.style.overflow = "";
  }
}

export default Menu;



// WEBPACK FOOTER //
// ./src/js/apps/menu.js